import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { getAuthAPIUrl } from "../api/apiUtils";
import './Authorization.scss';

const AUTH_API_BASE_URL = getAuthAPIUrl();

function Register({ setUser }) {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });

  const navigate = useNavigate();

  // Проверка: если пользователь уже авторизован, перенаправляем на главную
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      navigate("/");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Начало замера времени регистрации
    console.time('registerProcess');

    // Логирование попытки регистрации
    console.log('Попытка регистрации', {
      timestamp: new Date().toISOString(),
      username: credentials.username,
      action: 'register_initiated'
    });

    // Проверка совпадения паролей
    if (credentials.password !== credentials.confirmPassword) {
      console.error('Ошибка регистрации', {
        timestamp: new Date().toISOString(),
        username: credentials.username,
        error: 'Пароли не совпадают',
        action: 'register_failed'
      });
      console.timeEnd('registerProcess');
      alert("Пароли не совпадают");
      return;
    }

    // Проверка заполненности полей
    if (!credentials.username || !credentials.password) {
      console.error('Ошибка регистрации', {
        timestamp: new Date().toISOString(),
        username: credentials.username,
        error: 'Заполните все поля',
        action: 'register_failed'
      });
      console.timeEnd('registerProcess');
      alert("Заполните все поля");
      return;
    }

    try {
      // Отправка данных на сервер
      const response = await axios.post(`${AUTH_API_BASE_URL}/profile/register`, {
        username: credentials.username,
        password: credentials.password,
        confirmPassword: credentials.confirmPassword,
      });

      const { token } = response.data;

      // Логирование успешной регистрации
      console.log('Регистрация успешна', {
        timestamp: new Date().toISOString(),
        username: credentials.username,
        action: 'register_success'
      });

      // Завершение замера времени
      console.timeEnd('registerProcess');

      // Сохранение токена в localStorage
      localStorage.setItem("token", token);

      // Сохранение данных пользователя
      const userData = { role: "user", username: credentials.username, registerTime: new Date().toISOString() };
      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);

      // Перенаправление на главную страницу
      navigate("/");
    } catch (err) {
      // Логирование неуспешной регистрации
      console.error('Ошибка регистрации', {
        timestamp: new Date().toISOString(),
        username: credentials.username,
        error: err.response?.data?.error || err.message,
        action: 'register_failed'
      });

      // Завершение замера времени даже при ошибке
      console.timeEnd('registerProcess');

      alert(err.response?.data?.error || "Ошибка при регистрации");
    }
  };

  return (
    <div className="authorization">
      <div className="authorization-container-main mt-5">
        <div className="authorization-brand-text">Socio.Parser</div>
        <div className="authorization-container">
          <h2 className="authorization-title">Регистрация</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                className="authorization-custom-input"
                placeholder="Имя пользователя"
                value={credentials.username}
                onChange={(e) =>
                  setCredentials({ ...credentials, username: e.target.value })
                }
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="authorization-custom-input"
                placeholder="Пароль"
                value={credentials.password}
                onChange={(e) =>
                  setCredentials({ ...credentials, password: e.target.value })
                }
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="authorization-custom-input"
                placeholder="Подтвердите пароль"
                value={credentials.confirmPassword}
                onChange={(e) =>
                  setCredentials({ ...credentials, confirmPassword: e.target.value })
                }
              />
            </div>
            <button type="submit" className="btn authorization-custom-button">
              Зарегистрироваться
            </button>
          </form>
          <div className="authorization-link">
            Уже есть аккаунт? <Link to="/login">Войти</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
